import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import { canAccessMasters, canAccessFileManager, canAccessReports } from '../../utils/permissions.js';
import {
  LayoutDashboard, ClipboardList, FileText, ArrowLeftRight,
  FolderOpen, BarChart2, Settings, ScrollText, X
} from 'lucide-react';

const navItem = (to, icon, label, badge) => ({ to, icon, label, badge });

export default function Sidebar({ open, onClose }) {
  const { user } = useAuth();

  const navItems = [
    navItem('/dashboard', LayoutDashboard, 'Dashboard'),
    navItem('/gate-passes', ClipboardList, 'Gate Passes'),
    navItem('/delivery-notes', FileText, 'Delivery Notes'),
    navItem('/itrs', ArrowLeftRight, 'Internal Transfers'),
    ...(canAccessFileManager(user) ? [navItem('/files', FolderOpen, 'File Manager')] : []),
    ...(canAccessReports(user) ? [navItem('/reports', BarChart2, 'Reports')] : []),
    ...(canAccessFileManager(user) ? [navItem('/audit', ScrollText, 'Audit Log')] : []),
    ...(canAccessMasters(user) ? [navItem('/masters', Settings, 'Masters')] : []),
  ];

  return (
    <aside className={`
      fixed inset-y-0 left-0 z-30 w-64 bg-navy-800 text-white flex flex-col
      transform transition-transform duration-200 ease-in-out
      lg:relative lg:translate-x-0
      ${open ? 'translate-x-0' : '-translate-x-full'}
    `}>
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-4 border-b border-navy-700">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-teal-500 flex items-center justify-center flex-shrink-0">
            <ClipboardList className="w-4 h-4 text-white" />
          </div>
          <div>
            <p className="text-sm font-semibold leading-tight">Gate Pass</p>
            <p className="text-xs text-navy-300 leading-tight">Sreeragam Exports</p>
          </div>
        </div>
        <button onClick={onClose} className="lg:hidden text-navy-300 hover:text-white">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-0.5">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            onClick={onClose}
            className={({ isActive }) => `
              flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors
              ${isActive
                ? 'bg-teal-500/20 text-teal-300'
                : 'text-navy-200 hover:bg-navy-700 hover:text-white'
              }
            `}
          >
            <Icon className="w-5 h-5 flex-shrink-0" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* User info */}
      <div className="px-4 py-3 border-t border-navy-700">
        <p className="text-sm font-medium text-white truncate">{user?.name}</p>
        <p className="text-xs text-navy-400 truncate">{user?.email}</p>
      </div>
    </aside>
  );
}
